module.exports = __webpack_public_path__ + "img/Xizang-speed.ae3fa80d.png";